import { getQFromQuery } from '../../utils'
import { BufferSettingsQueryParams, BufferType } from '../types'

function getCombinedQueries({ radiusInMeters, geomField, tracts, baseQuery }: BufferSettingsQueryParams) {
  const queries: string[] = []
  const lastQuery = getQFromQuery(baseQuery) || 1
  for (let i = 1; i <= tracts; i++) {
    const base = `__q${lastQuery}`
    queries.push(`\tSELECT
\t\tST_Union_Agg(ST_Buffer(${geomField}, ${radiusInMeters * i})) AS geom
\tFROM
\t\t${base}`)
  }
  return queries
}

function getNonCombinedQueries({ radiusInMeters, geomField, columns, tracts, baseQuery }: BufferSettingsQueryParams) {
  const queries: string[] = []
  const lastQuery = getQFromQuery(baseQuery) || 1
  const columnsStr = `\t\t* EXCEPT (${geomField})`
  for (let i = 1; i <= tracts; i++) {
    const base = `__q${lastQuery}`
    queries.push(`\tSELECT${columns.length > 0 ? `\n${columnsStr},` : ''}
\t\tST_Buffer(${geomField}, ${radiusInMeters * i}) AS geom
\tFROM
\t\t${base}`)
  }
  return queries
}

export const generateQuery = (payload: BufferSettingsQueryParams) => {
  const { type, baseQuery } = payload
  const queries: string[] = []
  const lastQuery = getQFromQuery(baseQuery) || 1
  if (type === BufferType.NonCombined) {
    queries.push(...getNonCombinedQueries(payload))
  } else {
    queries.push(...getCombinedQueries(payload))
  }
  return `${baseQuery},\n__q${lastQuery + 1} AS (\n${queries.join('\n\nUNION ALL\n\n')}\n)\nSELECT * FROM __q${
    lastQuery + 1
  }`
}
